import qs from 'qs';
import instance from 'api';
import { AxiosRequestConfig } from 'axios';
import { EWorkTypes, IDefect, IRealEstate, IStatus } from './interfaces';

export const getDelayApplicationReportList = <T>(workType: EWorkTypes, config?: AxiosRequestConfig) => {
  return instance()
    .get<{ list: T[]; totalCount: number }>(`/applicationDelay/list${workType}`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true, arrayFormat: 'repeat' }),
    })
    .then((response) => response.data);
};

export const exportDelayApplicationReportListExcel = (workType: EWorkTypes, config?: AxiosRequestConfig) => {
  return instance()
    .get(`/applicationDelay/export${workType}Xls`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true, arrayFormat: 'repeat' }),
    })
    .then((response) => response.data);
};

export const exportDelayApplicationReportListPdf = (workType: EWorkTypes, config?: AxiosRequestConfig) => {
  return instance()
    .get(`/applicationDelay/export${workType}Pdf`, {
      ...config,
      paramsSerializer: (params) => qs.stringify(params, { allowDots: true, arrayFormat: 'repeat' }),
    })
    .then((response) => response.data);
};

export const getRealEstatesShort = (
  data: { searchWithCity?: boolean; nameWithCity?: boolean; isNoneService: boolean } = {
    searchWithCity: true,
    nameWithCity: true,
    isNoneService: true,
  },
) => {
  return instance()
    .post<IRealEstate[]>('/dictionary/realEstatesShort', data)
    .then((response) => response.data);
};

export const getDefectsShort = () => {
  return instance()
    .post<IDefect[]>('/dictionary/defectsByPositionShort', {})
    .then((response) => response.data);
};

export const getStatuses = () => {
  return instance()
    .post<IStatus[]>('/dictionary/status', {})
    .then((response) => response.data);
};
